import { SearchModel } from './common';

/**
 * Tipos para Log de Comunicação com a SEFAZ
 * conforme documentado em ERPApi/docs/funcionalidades/notas-fiscais/inutilizacao-e-comunicacao-sefaz.md
 *
 * Endpoints:
 *   GET /api/v1/sefaz-communication-logs
 *   GET /api/v1/sefaz-communication-logs/{id}
 *
 * Restrição: requer papel `admin` no token (permissão sefaz_communication_log.read).
 */

export type SefazServiceType =
  | 'INUTILIZACAO'
  | 'AUTORIZACAO'
  | 'RET-AUTORIZACAO'
  | 'CANCELAMENTO'
  | 'CONSULTA';

export const SEFAZ_SERVICE_TYPE_OPTIONS: { value: SefazServiceType; label: string }[] = [
  { value: 'INUTILIZACAO', label: 'Inutilização' },
  { value: 'AUTORIZACAO', label: 'Autorização' },
  { value: 'RET-AUTORIZACAO', label: 'Retorno da autorização (recibo)' },
  { value: 'CANCELAMENTO', label: 'Cancelamento' },
  { value: 'CONSULTA', label: 'Consulta' },
];

export const getSefazServiceTypeLabel = (value?: string | null): string => {
  if (!value) return '—';
  return SEFAZ_SERVICE_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value;
};

export interface SefazCommunicationLog {
  sefaz_log_id: number;
  company_id: number;
  company_name?: string | null;
  company_document?: string | null;
  service_type: SefazServiceType;
  model: number;
  serie?: number | null;
  invoice_number?: number | null;
  access_key?: string | null;
  invoice_id?: number | null;
  request_xml?: string | null;
  response_xml?: string | null;
  sefaz_status_code?: number | null;
  sefaz_status_description?: string | null;
  link_storage_request?: string | null;
  link_storage_response?: string | null;
  execution_time_ms?: number | null;
  created_at: string;
}

export interface SefazCommunicationLogListFilters extends SearchModel {
  /** Empresa — obrigatório no backend */
  company_id: number;
  service_type?: SefazServiceType;
  invoice_number?: number;
  serie?: number;
  access_key?: string;
  date_from?: string;
  date_to?: string;
}

export interface SefazCommunicationLogListResult {
  data: SefazCommunicationLog[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}
